var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "task-main",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "search-box btns"
  }, [_c('div', {
    staticClass: "form-item"
  }, [_vm._v(" 邀请码 "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.condition.ref_code,
      expression: "condition.ref_code"
    }],
    domProps: {
      "value": _vm.condition.ref_code
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.condition, "ref_code", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "form-item"
  }, [_vm._v(" 上级邀请码 "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.condition.parent_ref_code,
      expression: "condition.parent_ref_code"
    }],
    domProps: {
      "value": _vm.condition.parent_ref_code
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.condition, "parent_ref_code", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "form-item"
  }, [_vm._v(" 查询数量 "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.condition.limit,
      expression: "condition.limit"
    }],
    domProps: {
      "value": _vm.condition.limit
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.condition, "limit", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "form-item"
  }, [_vm._v(" 排序字段 "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.condition.sortField,
      expression: "condition.sortField"
    }],
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.condition, "sortField", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "coin"
    }
  }, [_vm._v(_vm._s(_vm.setting.coin))]), _c('option', {
    attrs: {
      "value": "ticket"
    }
  }, [_vm._v("TICKET")]), _c('option', {
    attrs: {
      "value": "stars"
    }
  }, [_vm._v("STARS")]), _c('option', {
    attrs: {
      "value": "ref_count"
    }
  }, [_vm._v("邀请数")])])]), _c('div', {
    staticClass: "btn btn-create",
    on: {
      "click": _vm.onRefresh
    }
  }, [_vm.isLoading ? [_vm._v("查询中...")] : [_vm._v("查询")]], 2)]), _c('div', {
    staticClass: "task-list"
  }, [_c('div', {
    staticClass: "task-list-item"
  }, [_c('div', {
    staticClass: "s"
  }, [_vm._v(" 用户ID ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 用户 ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 昵称 ")]), _c('div', {
    staticClass: "s"
  }, [_vm._v(" 邀请码 ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" " + _vm._s(_vm.setting.coin) + " ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 门票 ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 星星 ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 邀请用户数 ")]), _c('div', {
    staticClass: "s"
  }, [_vm._v(" 用户类型 ")]), _c('div', {
    staticClass: "s create"
  }, [_vm._v(" 最近登录 ")]), _c('div', {
    staticClass: "s create"
  }, [_vm._v(" 加入时间 ")])]), _vm._l(_vm.list, function (item, index) {
    return _c('div', {
      staticClass: "task-list-item"
    }, [_c('div', {
      staticClass: "s"
    }, [_vm._v(" " + _vm._s(item.id) + " ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.username) + " ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.firstname + " " + item.lastname) + " ")]), _c('div', {
      staticClass: "s"
    }, [_vm._v(" " + _vm._s(item.ref_code) + " ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.coin) + " ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.ticket) + " ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.stars) + " ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.ref_count) + " ")]), _c('div', {
      staticClass: "s"
    }, [_vm._v(" " + _vm._s(item.user_type == 0 ? '普通客户' : '' + item.user_type == 1 ? '合作伙伴' : '' + item.user_type == 2 ? '系统用户' : '') + " ")]), _c('div', {
      staticClass: "s create"
    }, [_vm._v(" " + _vm._s(_vm._f("formatTime")(item.login_token_time * 1000)) + " ")]), _c('div', {
      staticClass: "s create"
    }, [_vm._v(" " + _vm._s(_vm.cutStr(item.created_at)) + " ")])]);
  })], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };